export default __webpack_public_path__ + "static/media/J_Jacare.75c8964c.mp3";